import { preChat as ptPreChat } from '../pt/preChat';

export const preChat: typeof ptPreChat = {
  'Open the chat': 'Abrir el chat',
  'Leave the chat': 'Salir del chat',
  Leave: 'Salir',
  'You are chatting as': 'Estás hablando como',
  Close: 'Cerrar',
  'Talk to Vialaser': 'Habla con Vialaser',
  'Tell us your name and cellphone to start the conversation':
    'Ingresa tu nombre y celular para iniciar la conversación',
  'Full name': 'Nombre completo',
  Cellphone: 'Celular',
  PHONE_PLACEHOLDER: 'XXXX XXXXX',
  'I accept the <1>Terms and conditions</1> and I authorize the use of my data according to the <3>Privacy policy</3>':
    'Acepto los <1>Términos y condiciones</1> y autorizo el uso de mis datos de acuerdo con la <3>Declaracion de privacidad</3>.',
  'Start conversation': 'Iniciar conversación',
  'This field is required': 'Este campo es obligatorio',
  'Please, inform your name and last name': 'Ingresa tu nombre y apellido',
  'Please, inform a valid cellphone': 'Ingresa un celular válido',
  'Accept the terms to continue': 'Acepta los términos para continuar',
  'You are already a Vialaser client!': '¡Ya eres cliente de Vialaser!',
  'Sign in to your account to talk to us. This way we can help you with your data at hand':
    'Ingresa a tu cuenta para hablar con nosotros. Así te atendemos con tus datos a mano.',
  'Sign in': 'Ingresar',
  'Use another number': 'Usar otro número',
  'Opening the chat...': 'Abriendo el chat...',
  'Too many attempts. Wait a minute and try again':
    'Demasiados intentos. Espera un minuto e inténtalo de nuevo.',
  'We could not start the chat right now. Try again in a few moments':
    'No pudimos iniciar el chat ahora. Inténtalo de nuevo en unos momentos.',
  'We could not open the chat now. Try again later or talk to us on WhatsApp':
    'No pudimos abrir el chat ahora. Inténtalo más tarde o háblanos por WhatsApp.',
};
